import type { LabelMovementPayload } from "../../../types";
import { useEvent } from "../../changelog-item-context";
import { getEntityNameFromPayload, getMoveLabelVersions, getVersionNumber } from "../utils";

import LabelEventContent from "./LabelEventContent";

import { ActionType } from "@/queries";

type LabelAction = "created" | "deleted" | "moved";

const ACTION_TYPE_TO_LABEL_ACTION: Partial<Record<ActionType, LabelAction>> = {
  [ActionType.CREATE_LABEL]: "created",
  [ActionType.DELETE_LABEL]: "deleted",
  [ActionType.MOVE_LABEL]: "moved",
};

interface LabelActionEventTitleProps {
  actionType: ActionType;
}

const LabelActionEventTitle = ({ actionType }: LabelActionEventTitleProps) => {
  const event = useEvent();
  const action = ACTION_TYPE_TO_LABEL_ACTION[actionType]!;
  const payload = event.action_payload as LabelMovementPayload;

  const entityName = getEntityNameFromPayload(event.entity_type, payload);
  const labelName = payload?.label_name ?? "";

  if (action === "moved") {
    const { fromVersion, toVersion } = getMoveLabelVersions(event.entity_type, payload);
    return (
      <LabelEventContent
        action="moved"
        entityType={event.entity_type}
        entityName={entityName}
        fromVersion={fromVersion}
        toVersion={toVersion}
        workspaceId={event.workspace_id}
        entityId={event.entity_id?.toString() ?? null}
        labelName={labelName}
      />
    );
  }

  const version = getVersionNumber(event);
  return (
    <LabelEventContent
      action={action}
      entityType={event.entity_type}
      entityName={entityName}
      version={version}
      workspaceId={event.workspace_id}
      entityId={event.entity_id?.toString() ?? null}
      labelName={labelName}
    />
  );
};

export default LabelActionEventTitle;
